import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IProfile, IResponse } from '@interfaces/index';
import { AppService } from '@ui-components/services';
import { MatDialog } from '@angular/material/dialog';
import { switchMap } from 'rxjs';
import { ProfileService } from '../../services/profile.service';
import { IBasic } from 'projects/ui-components/src/interfaces/IProfile';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-basic',
  templateUrl: './basic.component.html',
  styleUrl: './basic.component.scss'
})
export class BasicComponent {

  form: FormGroup;
  loading = false;
  profile: IProfile | null = null;
  basic: IBasic | null = null;
  person_id: number | undefined;

  constructor(
    protected _app_service: AppService,
    protected _profile_service: ProfileService,
    protected _fb: FormBuilder,
    protected _route: ActivatedRoute,
    public router: Router,
    public dialog: MatDialog
  ) {
    this.form = this._fb.group({
      address1: [null],
      address2: [null],
      first_name: [null, Validators.required],
      last_name: [null, Validators.required],
      postal_code: [null],
      email: [null],
      person_id: [null],
      org_name: [null]
    })
  }

  ngOnInit() {
    this.loading = true
    this._app_service.getProfile().pipe(
      switchMap(
        (response: IResponse<IProfile>) => {
          this.profile = response.data;
          const person_id_param = this._route.snapshot.paramMap.get('person_id');
          this.person_id = person_id_param ? +person_id_param : undefined;
          this.form.patchValue({person_id: this.person_id});
          this.loading = false;
          return this._profile_service.getBasic(this.person_id);
        }
      )
    ).subscribe(
      (response: IResponse<IBasic>) => {
        this.form.patchValue(response.data);
        this.basic = response.data;
        this.form.get('email')?.setValue(this.basic.email_address); 
      }
    )
  }

  get email_change_link(): string {
    const { first_name, last_name } = this.form.value;
    const subject = `Email Address Change Request - ${first_name} ${last_name}`;
    const body = 'Hello,\nI am requesting that my email address be changed to [new email address]';
    return `mailto:info@owlhub.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  update(){
    this.loading = true;
    this._profile_service.updateBasic(this.form.value).subscribe(
      (response: IResponse<IBasic>) => {
        this.loading = false;
        this.basic = response.data;
      }
    )
  }


}
